<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar class="toolbar" flat dense>
        <!-- <v-toolbar-title> -->
        <v-row dense>
          <v-col cols="12" sm="3" md="3">
            <span style="font-size: 22px">Add Store Inventory </span>
          </v-col>
          <v-col cols="12" sm="6" md="6"></v-col>
          <v-col cols="12" sm="3" md="3" align="end">
            <v-btn class="mt-1" rounded color="success" small tile @click="opendialogbox()">
              <v-icon class="mr-2" small>mdi-file-import</v-icon>import Excel
            </v-btn>
          </v-col>
        </v-row>
      </v-toolbar>

      <v-card-text>
        <v-row justify="center">
          <v-col cols="12" sm="3" md="3">
            <b>Vendor </b><v-icon small class="pl-1 mb-3" color="error">*</v-icon>
            <v-select dense v-model="vendor" :items="vendor_list" item-text="name" item-value="id" outlined
              @change="getupdatedlist()" :rules="[(v) => !!v || 'required']" single-line
              :error="errorMsg.vendor ? true : false" :error-messages="errorMsg.vendor ? 'Required' : ''"></v-select>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <b>Vendor Shop </b><v-icon small class="pl-1 mb-3" color="error">*</v-icon>
            <v-select dense v-model="vendorshop" :items="vendorshop_list" @change="getItemCategoriesByVendorShop(vendor,vendorshop);resetSelections()" item-text="name" outlined item-value="id"
              :error="errorMsg.vendorshop ? true : false"
              :error-messages="errorMsg.vendorshop ? 'Required' : ''"></v-select>
          </v-col>
          <v-col cols="12" sm="3" md="3" v-if="vendorshop">
            <b>Item Category </b><v-icon small class="pl-1 mb-3" color="error">*</v-icon>
            <v-select dense v-model="itemcategory" :items="item_category_list" item-text="name" outlined
              :rules="[(v) => !!v || 'required']" item-value="id"
              @change="handleItemCategoryChange(itemcategory,vendor,vendorshop)" single-line
              :error="errorMsg.itemcategory ? true : false"
              :error-messages="errorMsg.itemcategory ? 'Required' : ''"></v-select>
          </v-col>
          <v-col cols="12" sm="3" md="3" v-if="itemcategory">
            <b>Item </b><v-icon small class="pl-1 mb-3" color="error">*</v-icon>
            <v-select dense v-model="item" :items="itemList" item-text="name" outlined
              @change="getSizeLableAndSizelableType(item)" item-value="id" :error="errorMsg.item ? true : false"
              :error-messages="errorMsg.item ? 'Required' : ''" single-line></v-select>
          </v-col>
        </v-row>
        <v-row dense justify="center" >
          <v-col cols="12" sm="3" md="3" v-if="item && sizeLabelTypeList.length > 0">
            <b>Size Lable Type</b><v-icon small class="pl-1 mb-3" color="error">*</v-icon>
            <v-select dense v-model="sizelabeltype" :items="sizeLabelTypeList" item-text="name" outlined item-value="id"
              readonly filled disabled @change="getsizelabletypedata()" :error="errorMsg.sizelabeltype ? true : false"
              :error-messages="errorMsg.sizelabeltype ? 'Required' : ''" single-line></v-select>
          </v-col>
          <v-col cols="12" sm="3" md="3" v-if="item && sizeLabelList.length > 0">
            <b>Size Lable </b><v-icon small class="pl-1 mb-3" color="error">*</v-icon>
            <v-select dense v-model="sizelabel" :items="sizeLabelList" item-text="name" outlined item-value="id"
              readonly filled disabled :error="errorMsg.sizelabel ? true : false"
              :error-messages="errorMsg.sizelabel ? 'Required' : ''" single-line></v-select>
          </v-col>
          <!-- <v-col cols="12" sm="3" md="3">
            <b>Standard </b>
            <v-icon small class="pl-1 mb-3" color="error">*</v-icon>
            <v-select dense v-model="standard" :items="standard_list" item-text="standardname" outlined disabled readonly filled
              item-value="standardid" :error="errorMsg.standard ? true : false"
              :error-messages="errorMsg.standard ? 'Required' : ''" multiple>
            </v-select>
          </v-col> -->
          <v-col cols="12" sm="2" md="2" align="center">
            <v-btn class="mt-7" color="info" rounded :loading="load" @click="savefetch">Fetch</v-btn>
          </v-col>
        </v-row>

        <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
          <v-checkbox dense v-model="isactive" color="success" label="Active ?"></v-checkbox>
        </v-col>
      </v-card-text>
      <v-row dense v-if="stock_list.length > 0">
        <v-toolbar class="toolbar" flat dense>
          <v-text-field class="" v-model="search" background-color="white" append-icon="mdi-magnify" label="Search"
                        single-line hide-details></v-text-field> 
          <v-spacer></v-spacer> 
          <v-btn rounded small class="ml-5" color="white" outlined @click="fnExcelReport('my-table-id', 'Stocks')"><v-icon color="white">mdi-export</v-icon>Export</v-btn>                
      </v-toolbar>
      </v-row>
      <v-row v-if="stock_list.length > 0">
        <v-col cols="12" sm="12" md="12">
          <v-simple-table dense class="elevation-1 mytable" id="my-table-id">
            <thead>
              <tr>
                <th class="">Sr. No.</th>
                <th class="">Vendor</th>
                <th class="">Vendor Shop</th>
                <th class="">Item Category</th>
                <th class="">Item Name</th>
                <th class="">Standard</th>
                <th class="">Size Label Type</th>
                <th class="">Size Label</th>
                <th class="">Available Quantity</th>
                <th class="">Minimum Stock</th>
              </tr>
            </thead>
            <tbody style="overflow-y: scroll">
              <tr v-for="(s, index) in filteredStockList" :key="s.id">
                <td>{{ index+1 }}</td>
                <td>{{ s.vendorname }}</td>
                <td>{{ s.vendorshopname }}</td>
                <td>{{ s.itemcategory }}</td>
                <td>{{ s.itemname }}</td>
                <td>
                  <span v-if="s.itemStandardlist && s.itemStandardlist.length">
                    {{ s.itemStandardlist.map(i => i.standardname).join(', ') }}
                  </span>
                  <span v-else>--</span>
                </td>
                <td>{{ s.sizelabeltypename || '--'}}</td>
                <td>{{ s.sizelabelname || '--'}}</td>
                <td>
                  <v-text-field type="number" min="0" class="pt-5" v-model="s.quantity" @keypress="onlyNumbers" outlined
                    dense></v-text-field>
                </td>
                <td>
                  <v-text-field type="number" min="0" class="pt-5" v-model="s.reorder_point" @keypress="onlyNumbers"
                    outlined dense></v-text-field>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <center>
            <v-btn :loading="loader" small @click="saveAllStockdata()" color="primary" class="mt-6">Save / Update</v-btn>
          </center>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="dialog1" max-width="900px" fullscreen>
      <v-card class="box">
        <v-toolbar dense class="toolbar" flat color="white">
          <v-toolbar-title>Import Stock</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog1 = false;file = null">
            <v-icon large>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-toolbar>

        <v-row dense justify="end">
          <v-col cols="12" sm="3" md="3" align="right" class="mr-4">
            <a href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/csv_files/import_stock.csv">
              <v-btn color="success" rounded outlined>
                Download CSV format
                <v-icon right dark>mdi-file-download</v-icon>
              </v-btn>
            </a>
          </v-col>
        </v-row>
        <v-row dense justify="center" class="mt-10">
          <v-col cols="12" sm="3" md="3"></v-col>
          <v-col cols="12" sm="4" md="4" class="mr-6">
            <v-file-input placeholder="Import CSV of Stock" prepend-icon="mdi-file-delimited" dense flat outlined
              show-size v-model="file"></v-file-input>
          </v-col>

          <v-col cols="12" sm="3" md="3">
            <v-btn class="info" @click="submit" :loading="output_load">Submit</v-btn>
          </v-col>
        </v-row>
        <v-row dense justify="center" class="mt-10">
                    <v-col sm="2">
                        <div v-if="vendor_list != null">
                            <v-simple-table dense class="elevation-2 mytable" v-if="vendor_list != ''">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-center">Vendor</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-center">
                                        <tr v-for="(item, index) in vendor_list" :key="index">
                                            <td>{{ item.name }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                    </v-col>
                    <v-col sm="2">
                        <div v-if="vendor_shop_list != null">
                            <v-simple-table dense class="elevation-2 mytable" v-if="vendor_shop_list != ''">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-center">Vendor Shop</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-center">
                                        <tr v-for="(item, index) in vendor_shop_list" :key="index">
                                            <td>{{ item.name }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                    </v-col>
                    <v-col sm="2">
                        <div v-if="item_category_list != null">
                            <v-simple-table dense class="elevation-2 mytable" v-if="item_category_list != ''">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-center">Item Category</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-center">
                                        <tr v-for="(item, index) in item_category_list" :key="index">
                                            <td>{{ item.name }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>

                        </div>
                    </v-col>
                    <v-col sm="2">
                        <div v-if="size_label_type_list != null">
                            <v-simple-table dense class="elevation-2 mytable" v-if="size_label_type_list != ''">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-center">Size Label Type</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-center">
                                        <tr v-for="(item, index) in size_label_type_list" :key="index">
                                            <td>{{ item.name }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                    </v-col>
                    <v-col sm="2">
                        <div v-if="size_label_list != null">
                            <v-simple-table dense class="elevation-2 mytable" v-if="size_label_list != ''">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-center">Size Label</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-center">
                                        <tr v-for="(item, index) in size_label_list" :key="index">
                                            <td>{{ item.name }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                    </v-col>
                    <v-col sm="2">
                        <div v-if="standard_list != null">
                            <v-simple-table dense class="elevation-2 mytable" v-if="standard_list != ''">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-center">Standard</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-center">
                                        <tr v-for="(item, index) in standard_list" :key="index">
                                            <td>{{ item.standardname }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                    </v-col>                
                </v-row>
        <br />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    valid: false,
    output_load:false,
    file:null,
    errorMsg: {
      vendor: false,
      itemcategory: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    items: [],
    itemList: [],
    dialog: false,
    search: "",
    loader: false,
    load: false,
    headers: [
      {
        text: "Name",
        value: "name",
      },
      {
        text: "Is Size Applicable ?",
        value: "is_size_applicable",
      },
      {
        text: "Active",
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
      { text: "Delete", value: "delete", sortable: false },
    ],
    item_list: [],
    stock_list: [],
    vendor_list: null,
    vendorshop_list: [],
    item_category_list: [],
    standard_list: [],
    size_label_list: [],
    size_label_type_list: [],
    vendor_shop_list:[],
    vendor: null,
    itemcategory: null,
    vendorshop: null,
    item: null,
    standard: null,
    editedIndex: -1,
    sizelabel: null,
    sizelabeltype: null,
    is_size_applicable: false,
    dialog1: false,
    sizeLabelList:[],
    sizeLabelTypeList:[]
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Item Category"
        : "Edit Item Category";
    },
    filteredStockList() {
      return this.stock_list.filter((s) => {
        const searchTerm = this.search.toLowerCase();
        return (
          s.vendorname.toLowerCase().includes(searchTerm) ||
          s.vendorshopname.toLowerCase().includes(searchTerm) ||
          s.itemcategory.toLowerCase().includes(searchTerm) ||
          s.itemname.toLowerCase().includes(searchTerm) ||
          (s.itemStandardlist &&
            s.itemStandardlist.some((i) => i.standardname.toLowerCase().includes(searchTerm)))
        );
      });
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {},
  mounted() {
    this.onload();
  },
  methods: {
    fnExcelReport(id, name) {
      let tab_text = `<table border='1px'>
            <tr>
            <th>Sr. No.</th>
            <th>Vendor</th>
            <th>Vendor Shop</th>
            <th>Item Category</th>
            <th>Item Name</th>
            <th>Standard</th>
            <th>Size Label Type</th>
            <th>Size Label</th>
            <th>Available Quantity</th>
            <th>Minimum Stock</th>
            </tr>`;

      this.stock_list.forEach((s) => {
        let standardList = s.itemStandardlist.map(std => std.standardname).join(", ");
        tab_text += `
            <tr>
                <td>${s.sr_no}</td>
                <td>${s.vendorname}</td>
                <td>${s.vendorshopname}</td>
                <td>${s.itemcategory}</td>
                <td>${s.itemname}</td>
                <td>${standardList}</td>
                <td>${s.sizelabeltypename}</td>
                <td>${s.sizelabelname}</td>
                <td>${s.quantity}</td>
                <td>${s.reorder_point}</td>           
            </tr>`;
      });

      tab_text += "</table>";

      const blob = new Blob([tab_text], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const filename = name + ".xls";

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    onlyNumbers(event) {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
    getSizeLableAndSizelableType(id) {
            const data = {

              item_id: id,
            };
            this.overlay = true;
            axios
                .post("/EduStoreSupplier/getSizeLabelFromItems", data)
                .then((res) => {
                    if (res.data.flag == "YES") {                    
                      this.sizeLabelTypeList = res.data.sizeLabelTypeList;
                      this.sizeLabelList = res.data.sizeLabelList;
                        if (this.sizeLabelList.length>0) {
                          this.sizelabel = this.sizeLabelList[0].id
                          this.sizelabeltype = this.sizeLabelList[0].sizeLabelTypeId
                        }                       
                      this.standard_list = res.data.standard_list;
                      this.standard = res.data.standard_list;
                    } else if (res.data.flag == "No") {                       
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
    },
    opendialogbox() {
      this.dialog1 = true;
    },
    handleItemCategoryChange(itemCategoryId,vendor_id,vendorShop_id) {
            const selectedCategory = this.item_category_list.find(
                (category) => category.id === itemCategoryId
            );
            this.is_size_applicable = selectedCategory.is_size_applicable || false;
            this.getsizelable(itemCategoryId,vendor_id,vendorShop_id);
        },
        getsizelable(itemCategory_id,vendor_id,vendorShop_id) {
            this.itemList = [];
            const data = {
                vendor_id : vendor_id,
                itemCategory_id: itemCategory_id,
                vendorShop_id: vendorShop_id
            };
            this.overlay = true;
            axios
                .post("/EduStoreSupplier/getItemFromVendorAndCategory", data)
                .then((res) => {
                  if (res.data.flag == "YES") {
                    
                        this.itemList = res.data.item_list;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        getItemCategoriesByVendorShop(vendor_id,vendorShop_id) {
            const data = {
                vendor_id : vendor_id,
                vendorShop_id: vendorShop_id
            };
            this.overlay = true;
            axios
                .post("/EduStoreSupplier/getItemCategoriesByVendorShop", data)
                .then((res) => {
                  if (res.data.flag == "YES") {   
                        this.item_category_list = res.data.item_category_list;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        resetSelections(){
          this.itemcategory = null;
          this.item = null;
          this.item_category_list = [];
          this.itemList = [];
        },
    submit() {
      if (this.file == null) {
        alert("Please select the file!");
      } else {
        this.output_load = true;
        let formData = new FormData();
        formData.append("file", this.file);
        axios
          .post("EduStoreSupplier/importStock", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            if (res.data.flag == "YES") {
              this.showSnackbar("success", "Uploaded successfully...");
              this.dialog1 = false;
              this.file = null;
              this.onload();
            }
            else if(res.data.flag == "NO"){
              this.showSnackbar("error",res.data.message)
            }
          })
          .catch(function () {
            console.log("FAILURE!!");
          })
          .finally(() => {
            this.output_load = false;
          });
      }
    },
    onload() {
      axios
        .post("/EduStoreSupplier/getaddstock")
        .then((res) => {
          if (res.data.msg == "200") {           
            this.vendor_list = res.data.vendor_list;
            this.item_category_list = res.data.item_category_list;
            this.size_label_list = res.data.size_label_list;
            this.size_label_type_list = res.data.size_label_type_list;
            this.vendor_shop_list = res.data.vendor_shop_list;
            this.standard_list = res.data.standard_list;
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    initializeErrorMsgFalse() {
      this.errorMsg.vendor = false;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    editItem(item) {
      this.editedIndex = this.item_category_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.initializeErrorMsgFalse();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    savefetch() {
        this.load = true;
        const data = {
          vendor: this.vendor,
          itemcategory: this.itemcategory,
          vendorshop: this.vendorshop,
          standard: this.standard,
          item: this.item,
          sizelabeltype: this.sizelabeltype,
          sizelabel: this.sizelabel,
        };
        axios
          .post("/EduStoreSupplier/fetchsavestockdata", data)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.stock_list = res.data.stock_list;
              this.load = false;        
            } else {
              this.load = false;
              this.showSnackbar("error", "Something went wrong..."); 
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.load = false;      
    },

    isValidated() {
      if (!this.vendor) {
        this.errorMsg.vendor = true;
        return false;
      } else if (!this.itemcategory) {
        this.errorMsg.itemcategory = true;
        return false;
      } else if (!this.vendorshop) {
        this.errorMsg.vendorshop = true;
        return false;
      } else if (!this.standard) {
        this.errorMsg.standard = true;
        return false;
      } else if (!this.item) {
        this.errorMsg.item = true;
        return false;
      } else if (this.is_size_applicable == true && !this.sizelabeltype) {
        this.errorMsg.sizelabeltype = true;
        return false;
      } else if (this.is_size_applicable == true && !this.sizelabel) {
        this.errorMsg.sizelabeltype = true;
        return false;
      } else {
        return true;
      }
    },
    toggle(item) {
      const data = {
        section_id: item.id,
        toggle: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/EduStore/toggleItemCategory", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Item Category Status Changed!");
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "error",
              "Something went wrong, Please try again later!"
            ); 
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    deleted(item) {
      if (!confirm("Are You Sure You Want To Delete ...?")) return;
      const data = {
        id: item.id,
      };
      this.overlay = true;
      axios
        .post("/EduStore/deleteItemCategory", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.onload();
            this.showSnackbar(
              "#4caf50",
              "Item Category Delete Successfully..."
            ); 
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "error",
              "Something went wrong, Please try again later!"
            );
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    getupdatedlist() {
      if (!this.vendor || this.vendor == null) {
        this.errorMsg.vendor = true;
        return false;
      }
      this.item = null;
      this.itemList = [];
      this.vendorshop = null;
      const data = {
        vendorid: this.vendor,
      };

      axios
        .post("/EduStoreSupplier/getVendorShops", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.flag == "YES") {
            this.vendorshop_list = res.data.vendorshoplist;
            this.item_category_list = res.data.item_category_list;
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "error",
              "Something went wrong, Please try again later!"
            ); 
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    getsizeupdatedlist(type) {
      const data = {
        itemcategory_id: this.itemcategory,
      };
      axios
        .post("/EduStoreSupplier/fetchItemcategorydata", data)
        .then((res) => {
          if (res.data.code == "SUCCESS") {
            this.is_size_applicable = res.data.is_size_applicable;
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "error",
              "Something went wrong, Please try again later!"
            ); 
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getsizelabletypedata() {
      const data = {
        sizelabeltype_id: this.sizelabeltype,
      };
      axios
        .post("/EduStoreSupplier/fetchsizelabletypedata", data)
        .then((res) => {
          if (res.data.code == "SUCCESS") {
            this.size_label_list = res.data.size_label_list;
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "error",
              "Something went wrong, Please try again later!"
            ); 
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    saveAllStockdata() {
      this.loader = true;
      const data = {
        stock_list: this.stock_list,
        vendor: this.vendor,
        itemcategory: this.itemcategory,
        vendorshop: this.vendorshop,
        standard: this.standard,
        item: this.item,
        sizelabeltype: this.sizelabeltype,
        sizelabel: this.sizelabel,
      };
      axios
        .post("/EduStoreSupplier/saveAllStockdata", data)
        .then((res) => {
          if (res.data.status.code == "SUCCESS") {
            this.showSnackbar("#4caf50", res.data.status.message); 
            this.stock_list = res.data.stock_list;
            this.loader = false;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.loader = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); 
          this.loader = false;
        })
        .finally(() => {
          this.loader = false;
        });
    },
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}
</style>
